import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {API_URL} from "lib-base";
import {Observable} from "rxjs";
import {ITipoDiscapacidad} from "../shared/interfaces/configuracion";

@Injectable({
  providedIn: 'root'
})
export class TipoDiscapacidadService {
  private baseUrl: string ;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tipo-discapacidad`;
  }

  getAll():Observable<ITipoDiscapacidad[]> {
    return this.http.get<ITipoDiscapacidad[]>(`${this.baseUrl}/public`);
  }

}
